import { AxiosRequestConfig } from "axios";
import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import AuthRequestPayload from "slotworks/model/gameplay/requests/auth-request-payload";
import { RequestBuilder } from "slotworks/server/builders/request-builder";

class AuthRequestBuilder implements RequestBuilder {
    public filter(data: any): boolean {
        return data instanceof AuthRequestPayload;
    }

    public build(gameplay: Gameplay, data: any) {


        let requestPayload: any = {
            cmd: "AUTH",
            game_id: RevolverModel.getGame(),
            launch_vars: {
                token: RevolverModel.getToken(),
                operator: RevolverModel.getOperator(),
                branding: RevolverModel.getBranding(),
                freeplay: RevolverModel.isFreeplay(),
                variant: RevolverModel.getVariant(),
                operatorId: RevolverModel.getOperatorId(),
                gameId: RevolverModel.getGameId()
            }
        };

        if (RevolverModel.getDemoCurrency()) {
            requestPayload.launch_vars['currency'] = RevolverModel.getDemoCurrency();
        }

        if (RevolverModel.getRegulation()) {
            requestPayload.launch_vars["regulation"] = RevolverModel.getRegulation();
        }

        return {
            method: "post",
            url: RevolverModel.getBaseURL(),
            data: JSON.stringify(requestPayload)
        } as AxiosRequestConfig;
    }
}

export default new AuthRequestBuilder();



// WEBPACK FOOTER //
// ./~/slotworks/integration/revolver/builders/requests/auth-request-builder.ts